module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('com-title', {
    attrs: {
      "title": "极客邦科技旗下产品及业务"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "content columns is-mobile"
  }, _vm._l((_vm.data), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "column is-half-mobile"
    }, [_c('a', {
      staticClass: "wrap",
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.word))])]), _vm._v(" "), _c('span', {
      staticClass: "line"
    })])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b600581","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/partner/com-prodserv.vue
// module id = 437
// module chunks = 1